import React, { Component } from 'react';
import { connect } from 'react-redux';

import { promotionPopupConfig } from './../../conf/config';

import Modal from './../UI/Modal/Modal';

export class Points extends Component {

    state = {
      showPopup: false
    }

    isCookieExists = (name) => {
      var nameEQ = name.replace(" ", "_") + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)===' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) === 0) return true;
      }

      return false;
    }

    setCookie = (name, value, days) => {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name.replace(" ", "_") + "=" + (value || "")  + expires + "; path=/";
    }

    componentDidMount(){
      let startDateArray = promotionPopupConfig.startDate.split("/");
      let startDateFormat = startDateArray[1] + '/' + startDateArray[0] + '/' + startDateArray[2];
      let endDateArray = promotionPopupConfig.endDate.split("/");
      let endDateFormat = endDateArray[1] + '/' + endDateArray[0] + '/' + endDateArray[2];
      let startDate = new Date(startDateFormat);
      let endDate = new Date(endDateFormat);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      let currentDate = Date.now();

      if(!this.isCookieExists(promotionPopupConfig.name) && startDate<currentDate && endDate>currentDate)
      {
        this.setState({showPopup: true});

        this.setCookie(promotionPopupConfig.name, true, promotionPopupConfig.nbDayBeforeExpire);
      }
    }

    closeModalHandler = () => {
      this.setState({showPopup: false});
    }

    onClickHandler = () => {
      window.open(promotionPopupConfig.redirectLink,'_blank');
    }
    
    render(){
        let modal = null;

        //let PopupImgMobile = '/assets/images/promotions/' + promotionPopupConfig.imgName;
        //let PopupImgDesk = '/assets/images/promotions/' + promotionPopupConfig.imgNameDesk;

        if (this.state.showPopup){
            modal = (
                <div className="promotion-modal">
                    <div className="modal-container">
                        <div className={`close-button ${promotionPopupConfig.closebtnLight?"light":"sombre"}`} onClick={this.closeModalHandler}></div>
                        <div className="content" onClick={this.onClickHandler}>
                            <img src={promotionPopupConfig.imgName} alt={promotionPopupConfig.name}/>
                        </div>
                        <div className="content-desk" onClick={this.onClickHandler}>
                            <img src={promotionPopupConfig.imgNameDesk} alt={promotionPopupConfig.name}/>
                        </div>
                    </div>
                </div>
            );
        }

        return (
                <Modal show={this.state.showPopup} modalClosed={this.closeModalHandler} class="promotion-modal-container">
                    {modal}
                </Modal>
        );
        
    }
}
  
export default connect( null )(Points);



// WEBPACK FOOTER //
// ./src/components/PromotionPopup/PromotionPopup.js